// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunnelPlotTwoToneSvg from "@ant-design/icons-svg/es/asn/FunnelPlotTwoTone";
import AntdIcon from '../components/AntdIcon';

var FunnelPlotTwoTone = function FunnelPlotTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotTwoToneSvg
  }));
};

FunnelPlotTwoTone.displayName = 'FunnelPlotTwoTone';
export default React.forwardRef(FunnelPlotTwoTone);